import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { CountryDetails } from '../CountryDetails';
import { RoamersSegment } from '../RoamersSegment';




@Component({
  selector: 'app-roamers-segment',
  templateUrl: './roamers-segment.component.html',
  styleUrls: ['./roamers-segment.component.scss']
})
export class RoamersSegmentComponent implements OnInit, OnDestroy {

  private dateToString = (date: any) => `${date.year}-${date.month}-${date.day}`;

  roamerSegmentForm: FormGroup;
  dataSource = [];
  country = [];
  network = [];
  VPMNCountry = [];
  VPMNnetwork = [];
  HPMNtadig = [];
  VPMNtadig=[];
  showTable: boolean;
  messageCategory = ["MessageCategory1", "MessageCategory2", "MessageCategory3"]

  constructor(private formBuilder: FormBuilder,
    private endpointsService: EndpointsService,
    private httpClient: HttpClient,
    private backendApiService: BackendApiService) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.createRoamersSegmentForm();
    this.getCountryDetails();
    this.storeAnalytics();
  }



  createRoamersSegmentForm() {
    this.roamerSegmentForm = this.formBuilder.group({
      country: ['1'],
      network: ['1'],
      msgCatergory: ['1'],
      startDate: [],
      endDate: [],
      msidn: [],
      VPMNCountry: ['1'],
      VPMNnetwork: ['1'],
      HPMNtadig: ['1'],
      VPMNtadig:['1']
    });
  }

  changedateEvent(targetCalendarId: any) {
    

    targetCalendarId.toggle();
  }

  search() {
    let url = this.endpointsService.ROAMERS_SEGMENT_DETAILS;
    let countryData = this.roamerSegmentForm.get('country').value;
    if (countryData) {
      url += "&country=" + countryData
    }
    let networkData = this.roamerSegmentForm.get('network').value;
    if (networkData) {
      url += "&network=" + networkData
    }
    let msgCatergory = this.roamerSegmentForm.get('msgCatergory').value;
    if (msgCatergory) {
      url += "&msgCatergory=" + msgCatergory
    }
    let startDate = this.roamerSegmentForm.get('startDate').value;
    if (startDate) {
      url += "&startDate=" + this.roamerSegmentForm.get('startDate').value;
    }
    let endDate = this.roamerSegmentForm.get('endDate').value;
    if (endDate) {
      url += "&endDate=" + this.roamerSegmentForm.get('endDate').value;
    }
    let msidn = this.roamerSegmentForm.get('msidn').value;
    if (msidn) {
      url += "&msisdn=" + msidn
    }
    
    this.backendApiService.callToApi(url).subscribe(res => {
      this.dataSource = res;
      this.showTable = true;
    });
  }

  getCountryDetails() {
    this.backendApiService.callToApi(this.endpointsService.COUNTRY_DETAILS).subscribe(res => {
      
      this.country = res;
    });
  }

  networkValues() {
    this.getNetworkDetails()
  }

  getNetworkDetails() {
    let cntry = this.roamerSegmentForm.get('country').value.split("_")[1]
    
    this.backendApiService.callToApi(this.endpointsService.NETWORK_DETAILS
      + "&country=" + cntry)
      .subscribe(res => {
        this.network = res;
      });
  }

  reset(){
    this.createRoamersSegmentForm();
    this.showTable = false;
  }
  async storeAnalytics() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=repitativecount' + '&operation=datafilter';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });


  }
}
